import { computed } from 'vue'
import { useStore } from 'vuex'

const FIAT_SYMBOLS = {
  USD: '$',
  EUR: '€',
  TRY: '₺',
  BRL: 'R$',
  GBP: '£',
  CNY: '¥',
  JPY: '¥',
  KRW: '₩',
  INR: '₹',
  RUB: '₽',
  MXN: '$',
  CAD: '$',
  AUD: '$',
  CHF: 'CHF',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  ZAR: 'R',
  PHP: '₱',
  THB: '฿',
  VND: '₫',
  ARS: '$',
  COP: '$',
  CLP: '$',
  SGD: '$',
  MYR: 'RM'
}

export function useCurrency() {
  const store = useStore()

  const userFiat = computed(() => {
    return store.getters.authUser?.user?.currency?.fiatCurrency || 'USD'
  })

  const exchangeRates = computed(() => {
    return store.state.general?.generalSettings?.exchangeRates || { USD: 1 }
  })

  const rate = computed(() => {
    return exchangeRates.value[userFiat.value] || 1
  })

  const symbol = computed(() => {
    return FIAT_SYMBOLS[userFiat.value] || userFiat.value
  })

  function formatFiat(usdAmount, options = {}) {
    if (usdAmount == null || isNaN(usdAmount)) return '0.00'

    const converted = usdAmount * rate.value

    const formatted = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: options.min ?? 2,
      maximumFractionDigits: options.max ?? 2
    }).format(converted)

    // 🔥 symbol position
    if (options.symbolPosition === 'right') {
      return `${formatted} ${symbol.value}`
    }

    // default: left
    return `${symbol.value}${formatted}`
  }

  return {
    userFiat,
    rate,
    symbol,
    formatFiat
  }
}
